module.exports = __webpack_public_path__ + "media/images/lp/industries/mv_automotive-6806a2ec9f99807c51a20421c14c876e.png";